import { categories } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function FeatureGrid() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-sm text-foreground-500 font-medium tracking-wide">分类浏览</p>
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mt-2">
            探索你喜欢的类型
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg">
            八大分类，海量韩漫。从恋爱到热血，从奇幻到悬疑，总有一款适合你。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-7 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="font-heading text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 text-center leading-relaxed hidden sm:block">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}